export * as date from './date';
export * as colors from './colors';
export { collectPath } from './theme';
export const getScrollbarWidth = (function getScrollbarWidth() {
    let width = 0;
    function calc() {
        if (typeof window === 'undefined') {
            return 0;
        }
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.position = 'absolute';
        outer.style.overflow = 'scroll';
        const inner = document.createElement('div');
        outer.appendChild(inner);
        document.body.appendChild(outer);
        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
        document.body.removeChild(outer);
        return scrollbarWidth;
    }
    return function cachedWidth() {
        width = width || calc();
        return width;
    };
})();
/**
 * react-aria местами примешивает в пропсы всякий приватный мусор с рандомными айдишниками
 * (например __role_234124123412341 или другие похожие ключи),
 * который крашит ssr, и приходится вырезать его вот такой утилитой
 * */
export function cutTrashProps(props) {
    const sanitizedProps = {};
    for (let key in props) {
        if (key.startsWith('__'))
            continue;
        sanitizedProps[key] = props[key];
    }
    return sanitizedProps;
}
